import React, { useEffect, useState } from 'react';
import '../../../vendors/NavigationTab.scss';
import ProfilePlaceHolder from '../../../../assets/image/emailPlaceHolder.svg';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getCustomerDetail } from '../../../../services/customers';
import { getDoctorDetail } from '../../../../services/doctors';
import Drawer from '../../../../component/Drawer';
import CustomDetails from './customDetails';

function CustomDrawer({ isOpen, onClose, id, drawerType, activeDrawer }) {
	const [activeTab, setActiveTab] = useState('Details');
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const navTabs = ['Details'];
	const [details, setDetails] = useState({});

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Details':
				return (
					<CustomDetails
						details={details}
						type={drawerType}
					/>
				);
			default:
				return null;
		}
	};

	function handleViewMoreDetails() {
		if (drawerType === 'customer') {
			navigate(`/user/${suburl}/customers-details/${details?.id}`);
		} else if (drawerType === 'doctor') {
			navigate(`/user/${suburl}/doctors-details/${details?.id}`);
		}
	}

	useEffect(() => {
		function handleSetActiveTab() {
			setActiveTab(activeDrawer);
		}
		handleSetActiveTab();
	}, [activeDrawer]);

	async function fetchDrawerDetails() {
		try {
			if (drawerType === 'customer') {
				const { customer_details } = await getCustomerDetail(id);
				setDetails(customer_details);
			} else if (drawerType === 'doctor') {
				const { doctor } = await getDoctorDetail(id);
				setDetails(doctor);
			}
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	useEffect(() => {
		if (id) {
			fetchDrawerDetails();
		}
	}, [id]);

	return (
		<Drawer
			handleViewMoreDetails={handleViewMoreDetails}
			isOpen={isOpen}
			onClose={onClose}
			title={
				drawerType === 'customer'
					? 'Customer Details'
					: drawerType === 'doctor'
						? 'Doctor Details'
						: ''
			}
		>
			<br />

			<div
				className="d-flex"
				style={{ gap: '20px' }}
			>
				<div className="profileImage d-flex align-self-center justify-content-sm-center">
					<img
						src={ProfilePlaceHolder}
						alt=""
						style={{ width: '55px', borderRadius: '10px' }}
					/>
				</div>

				<div
					className="d-flex flex-column"
					style={{ gap: '15px' }}
				>
					<div
						style={{
							fontSize: '18px',
							fontWeight: '600',
							color: '#333',
						}}
					>
						{details?.name}
					</div>

					<div
						style={{
							fontSize: '14px',
							color: 'var(--sub, #555B67)',
						}}
					>
						{`${details?.mobile ?? details.phone ?? ''} | ${details.email ?? ''}`}
					</div>
				</div>
			</div>
			<br />
			<hr />

			{/* tabs  */}
			<div>
				<ul className="nav mb-4 mt-2">
					{navTabs.map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<a
								className={`nav-link ${activeTab === item && 'active'} cursur-pointer`}
								href="#"
								onClick={(e) => {
									e.preventDefault();
									setActiveTab(item);
								}}
							>
								{item}
							</a>
						</li>
					))}
				</ul>
				<hr
					style={{
						backgroundColor: '#E3E4E5',
						boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
						marginTop: '-13px',
					}}
				/>
				<div className="pb-4">{renderTabContent()}</div>
			</div>
		</Drawer>
	);
}

export default CustomDrawer;
